import { render, staticRenderFns } from "./VisualizarContratoOriginacaoEmpresa.vue?vue&type=template&id=2845f960&scoped=true&lang=pug"
import script from "./VisualizarContratoOriginacaoEmpresa.vue?vue&type=script&lang=js"
export * from "./VisualizarContratoOriginacaoEmpresa.vue?vue&type=script&lang=js"
import style0 from "./VisualizarContratoOriginacaoEmpresa.vue?vue&type=style&index=0&id=2845f960&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2845f960",
  null
  
)

export default component.exports